//RENAME THIS FILE ONCE WE KNOW MORE OF WHICH FUNCTIONS ARE HOSTED HERE
import {
  SAVE_BOOKING_FORM,
  SAVED_BOOKING_FORM,
  UPDATE_BOOKING_FORM,
  GOT_EXISTING_BOOKING,
  GOT_UPDATED_TOKEN,
  GET_BOOKING_PRINTABLE_VERSION,
  GOT_BOOKING_PRINTABLE_VERSION,
  GET_EXISTING_BOOKING,
  SEND_BOOKING_EMAIL,
  SENT_BOOKING_EMAIL,
  GET_SIBBLING_BOOKING,
  GOT_SIBBLING_BOOKING,
  GOT_PURCHASED_OFFER,
  GET_PURCHASED_OFFER,
  REMOVE_OFFER_FROM_FORM,
} from "../actions/booking";
import {
  UPDATED_APPOINTMENT_STEP_DATA,
  GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES,
} from "../actions/appointmentStep";
import { UPDATED_ADVANCED_APPOINTMENT_STEP_DATA } from "../actions/appointmentAdvancedStep";
import { UPDATED_GLOBAL_ERROR_MESSAGE } from "../actions/globalError";
import { appStatusInitialState, offersStatusEnum } from "../state/initialState";
import objectAssign from "object-assign";
export default (state = appStatusInitialState, action) => {
  let newStatus;
  switch (action.type) {
    case SAVE_BOOKING_FORM:
      newStatus = {
        savingBooking: true,
      };
      return objectAssign({}, state, newStatus);
    case REMOVE_OFFER_FROM_FORM:
      newStatus = {
        gotValidOffer: false,
      };
      return objectAssign({}, state, newStatus);
    case GOT_PURCHASED_OFFER:
      newStatus = {
        loadingPurchasedOffer: false,
        gotValidOffer: action.data.found,
      };
      return objectAssign({}, state, newStatus);
    case UPDATE_BOOKING_FORM:
      newStatus = {
        savingBooking: true,
      };
      return objectAssign({}, state, newStatus);
    case GET_PURCHASED_OFFER:
      newStatus = {
        loadingPurchasedOffer: true,
      };
      return objectAssign({}, state, newStatus);
    case GET_SIBBLING_BOOKING:
      newStatus = {};
      newStatus[`loadingSibblingBooking_${action.payload.bookingId}`] = true;
      newStatus.finishedLoadingSibblingBookings = false;

      return objectAssign({}, state, newStatus);
    case GOT_SIBBLING_BOOKING:
      newStatus = {};
      newStatus[
        `loadingSibblingBooking_${action.data.currentBookingId}`
      ] = false;
      newStatus.sibblingsLoaded = state.sibblingsLoaded + 1;

      if (
        state.sibblingBookingIds &&
        newStatus.sibblingsLoaded == state.sibblingBookingIds.length
      ) {
        newStatus.isSibblingsMissingInUpdate = false;
        newStatus.finishedLoadingSibblingBookings = true;
        if (newStatus.sibblingsLoaded == 1) {
          // in some cases GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES is not dispatched while opening multiservice appt until user clicks somewhere on screen. Hence setting this to take the snapshot.
          newStatus.finishedLoadingSibblingResources = true;
        }
      }

      const status =
        action.data.appointmentStepData.multiServiceList[0].sibblingStatus; //DES-751 Dont add cancelled appointments to the sibbling count.
      if (
        status === 5 ||
        (status === 6 && state.sibblingBookingsTotalStartingFromZero > 0)
      ) {
        newStatus.sibblingBookingsTotalStartingFromZero =
          state.sibblingBookingsTotalStartingFromZero - 1;
      }
      return objectAssign({}, state, newStatus);
    case GET_BOOKING_PRINTABLE_VERSION:
      newStatus = {
        loadingBookingPrintableBlob: true,
      };
      return objectAssign({}, state, newStatus);
    case SEND_BOOKING_EMAIL:
      newStatus = {
        sendingBookingEmail: true,
      };
      return objectAssign({}, state, newStatus);
    case SENT_BOOKING_EMAIL:
      newStatus = {
        sendingBookingEmail: false,
      };
      return objectAssign({}, state, newStatus);
    case GOT_BOOKING_PRINTABLE_VERSION:
      newStatus = {
        bookingPrintableVersionBlob: action.data,
        loadingBookingPrintableBlob: false,
      };
      return objectAssign({}, state, newStatus);
    case GOT_UPDATED_TOKEN:
      if (action.data.authorization)
        sessionStorage.setItem(
          "token_authorization",
          `GENBOOK-TOKEN ${action.data.authorization}`
        );
      else console.warn("token is undefined");

      return state;
    case UPDATED_GLOBAL_ERROR_MESSAGE:
      newStatus = {
        loadingPurchasedOffer: false,
        savingBooking: false,
      };
      return objectAssign({}, state, newStatus);
    case GET_EXISTING_BOOKING:
      newStatus = {
        loadingBooking: true,
        currentBookingId: action.payload.bookingId,
      };
      return objectAssign({}, state, newStatus);
    case SAVED_BOOKING_FORM:
      newStatus = {
        savingBooking: false,
        currentBookingId: action.data.currentBookingId,
        bookingReference: action.data.confirmationIdentifier,
      };

      return objectAssign({}, state, newStatus);
    case GOT_EXISTING_BOOKING:
      newStatus = {
        bookingChannel: action.data.bookingChannel,
        currentBookingId: action.data.currentBookingId,
        bookingReference: action.data.confirmationIdentifier,
        loadingBooking: false,
        isMultiServiceAppointment: action.data.isMultiServiceAppointment,
        sibblingBookingIds: action.data.sibblingBookingIds,
        finishedLoadingSibblingBookings: false,
        sibblingBookingsTotalStartingFromZero:
          action.data.sibblingBookingsTotalStartingFromZero,
        gotValidOffer: action.data.gotValidOffer,
        sibblingsLoaded: 0,
        finishedLoadingSibblingResources: false,
        resourcesLoadedForSibblings: 0,
        loadedResourcesForAllSibblings: -1,
        alert:
          (action.data &&
            action.data.invoiceData &&
            action.data.invoiceData.alert) ||
          null,
      };

      if (action.data.sibblingBookingIds.length == 0) {
        // if there are no sibblings, mark finishedLoadingSibblingBookings as true
        newStatus.finishedLoadingSibblingBookings = true;
      }
      return objectAssign({}, state, newStatus);
    case GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES:
      newStatus = {};

      if (state.finishedLoadingSibblingBookings) {
        newStatus.resourcesLoadedForSibblings =
          state.resourcesLoadedForSibblings + 1;
      }

      if (
        state.sibblingBookingIds &&
        newStatus.resourcesLoadedForSibblings == state.sibblingBookingIds.length
      ) {
        newStatus.finishedLoadingSibblingResources = true;

        if (state.loadedResourcesForAllSibblings == -1) {
          // in some cases this action is not dispatched while opening multiservice appt until user clicks somewhere on screen. Then we need to take snapshot again. otherwise save pop up triggers.
          newStatus.loadedResourcesForAllSibblings =
            newStatus.resourcesLoadedForSibblings;
        }
      }

      return objectAssign({}, state, newStatus);
    case UPDATED_APPOINTMENT_STEP_DATA:
      newStatus = {};
      if (state.loadedResourcesForAllSibblings > 0) {
        // once GOT_BOOKINGS_FOR_RESOURCE_WITHIN_DATES fired need not take snapshot.
        newStatus.loadedResourcesForAllSibblings = 0;
      }

      return objectAssign({}, state, newStatus);
    default:
      return state;
  }
  return state;
};
